import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RoleRoute = ({ allow = [] }) => {
  const { user } = useAuth();
  const role = user?.userRole;

  if (!role || (allow.length > 0 && !allow.includes(role))) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

RoleRoute.propTypes = {
  allow: PropTypes.arrayOf(PropTypes.string),
};

RoleRoute.defaultProps = {
  allow: [],
};

export default RoleRoute;

